module.exports = __webpack_public_path__ + "static/img/preview-01.7e208e08.webp";